import { FC, ReactNode } from 'react';
import { Heading, Section } from 'components';
import ageImage from 'assets/images/age.svg';
import navigationImage from 'assets/images/navigation.svg';
import targetImage from 'assets/images/target.svg';
import S from './RequirementsSection.Styled';

interface RequirementsSectionProps {
  backgroundColor?: string;
  title: string;
  subtitle: string;
  labels: ReactNode[];
}

interface RequirementItem {
  icon: string;
  iconAlt: string;
  smallLabel: string;
  label: ReactNode;
}

const items = [
  { icon: ageImage, iconAlt: 'Ηλικία', smallLabel: 'ηλικια' },
  { icon: navigationImage, iconAlt: 'Πλοήγηση', smallLabel: 'περιοχη' },
  { icon: targetImage, iconAlt: 'Στόχος', smallLabel: 'στοχος' },
];

const Item: FC<RequirementItem> = ({ icon, iconAlt, smallLabel, label }) => {
  return (
    <S.Item>
      <S.ItemIcon>
        <img src={icon} alt={iconAlt} />
      </S.ItemIcon>
      <S.ItemSmallLabel>{smallLabel}</S.ItemSmallLabel>
      <S.ItemLabel>{label}</S.ItemLabel>
    </S.Item>
  );
};

export const RequirementsSection: FC<RequirementsSectionProps> = ({ backgroundColor, title, subtitle, labels }) => {
  return (
    <Section backgroundColor={backgroundColor}>
      <S.Container>
        <S.TextContainer>
          <Heading>{title}</Heading>
          <S.Subtitle>{subtitle}</S.Subtitle>
        </S.TextContainer>
        <S.RequirementsContainer>
          {items.map((item, index) => (
            <Item key={item.smallLabel} {...item} label={labels[index]} />
          ))}
        </S.RequirementsContainer>
      </S.Container>
    </Section>
  );
};
